import { type SerializedStyles, css } from '@emotion/react'
import { type ReactNode } from 'react'

import mediaQueries from '@/layout/media-queries'

const wrapperCss = css`
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  z-index: 2;
  display: none;
  transform: translateY(-50%);

  ${mediaQueries.smallScreen()} {
    display: flex;
  }
`

interface Props {
  children: ReactNode
  className: SerializedStyles
}

export const ChevronWrapper = ({ children, className }: Props) => (
  <div css={[wrapperCss, className]}>{children}</div>
)
